import { forwardRef, useEffect, useRef } from "react";
import { Footer } from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import Header from "@components/Header/Header";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import useNotifications from "@features/Notification/useNotifications";
import Sidebar from "@components/Sidebar/Sidebar";
import ModalManager from "@components/common/ModalManager/ModalManager";

export const MainLayout = forwardRef<HTMLElement>(() => {
	const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);
	const userEmail = useSelector((state: RootState) => state.user.user?.emailAddress);
	const { fetchInitial } = useNotifications();
	const fetchedRef = useRef(false);

	useEffect(() => {
		if (isAuthenticated && !fetchedRef.current) {
			fetchInitial();
			fetchedRef.current = true;
		}
	}, [isAuthenticated, fetchInitial]);

	// Update document title based on user email
	useEffect(() => {
		document.title = "Organization Administrator";
	}, [userEmail]);

	return (
		<div className="min-h-screen flex flex-col bg-[#F7FAFD]">
			<Header />
			<Sidebar />
			<div className="flex-1 ml-72">
				<main className="p-2">
					<Outlet />
				</main>
			</div>
			<Footer />
			<ModalManager />
		</div>
	);
});
